module.exports = __webpack_public_path__ + "img/screen_lock_portrait.d50d0e9b.svg";